import { SxProps, Theme } from "@mui/material";

export const TEXT_FIELD_SX: SxProps<Theme> = { width: { xs: "100%", md: 300, lg: 450, xl: 700 } };
export const TYPOGRAPHY_TITLE_SX: SxProps<Theme> = { whiteSpace: "nowrap", minWidth: { md: 100 } };
